(function () {
  const initSection = (section) => {
    if (!section) return;

    const id = section.getAttribute("id");
    const swiperEl = section.querySelector(".images-with-text__slider");
    if (!id || !swiperEl || swiperEl.dataset.threeUpInitialized === "true") return;

    swiperEl.dataset.threeUpInitialized = "true";

    const imageWidth = swiperEl.dataset.imagewidth;
    const largeImage = imageWidth === "large";
    const carouselType = swiperEl.dataset.carouseltype;
    const isSlide = carouselType === "slide";
    const speed = Number(swiperEl.dataset.speed || 1) * 1000;
    const slidesCount = Number(swiperEl.dataset.realSlides || 0);
    const gap = isSlide ? 24 : 4;

    if (slidesCount < 5 && slidesCount > 2 && !isSlide) {
      const wrapper = swiperEl.querySelector(".swiper-wrapper");
      if (wrapper) wrapper.innerHTML += wrapper.innerHTML;
    }

    new Swiper(`#${id} .swiper`, {
      loop: slidesCount > 3,
      slidesPerView: largeImage ? 1.9 : 2.2,
      spaceBetween: isSlide ? 8 : 4,
      speed: speed,
      allowTouchMove: true,
      breakpoints: {
        990: {
          slidesPerView: 3,
          spaceBetween: gap,
        },
      },
      autoplay: isSlide
        ? true
        : {
            delay: 0,
          },
      freeMode: {
        enabled: true,
        momentum: false,
      },
      on: {
        init() {
          this.slides.forEach((slide, i) => {
            const isFocusable = i < slidesCount;
            slide.toggleAttribute("tabindex", isFocusable);
            slide.classList.toggle("focus-inset", isFocusable);
          });
        },
      },
    });

    const animatedElements = section.querySelectorAll(".preFade");
    if (animatedElements.length) {
      const observer = new IntersectionObserver(
        (entries, activeObserver) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("fadeIn");
              activeObserver.unobserve(entry.target);
            }
          });
        },
        { threshold: 0 }
      );
      animatedElements.forEach((el) => observer.observe(el));
    }
  };

  initSection(document.currentScript && document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", (event) => {
    if (event.target.querySelector(".images-with-text--three-up")) {
      initSection(event.target);
    }
  });
})();
